import { getValueFromStorage, putValueToStorage, removeValueFromStorage } from '@Pages/RetroSynthesis/utils';

export const RS_SAVED_LOCATION_STORAGE_KEY = 'rs-saved-location';

export const getRsSavedLocation = () => getValueFromStorage(RS_SAVED_LOCATION_STORAGE_KEY, true);

export const saveRsLocation = (location) => {
  putValueToStorage(RS_SAVED_LOCATION_STORAGE_KEY, location, true);
};

export const clearRsSavedLocation = () => {
  removeValueFromStorage(RS_SAVED_LOCATION_STORAGE_KEY, true);
};
